import { ucFirst } from "../Services/helpers";

const dateRanges = {
    'allTime'         : 'All time',
    'lastYear'        : 'Last Year',
    'thisYear'        : 'This Year',
    'lastMonth'       : 'Last Month',
    'thisMonth'       : 'This Month',
    'lastTwelveMonths': 'Last 12 Months',
    'lastSixMonths'   : 'Last 6 Months',
    'lastThreeMonths' : 'Last 3 Months',
    'lastWeek'        : 'Last Week',
    'thisWeek'        : 'This Week',
    'yesterday'       : 'Yesterday',
    'today'           : 'Today',
}

const futureDateRanges = {
    'thisYear'        : 'This Year',
    'nextYear'        : 'Next Year',
    'nextTwelveMonths': 'Next 12 Months',
    'nextThreeMonths' : 'Next 3 Months',
    'thisMonth'       : 'This Month',
    'nextMonth'       : 'Next Month',
    'nextWeek'        : 'Next Week',
    'tomorrow'        : 'Tomorrow',
}

const periods = [
    'date',
    'week',
    'month',
    'year',
];

const selectableDateRanges = Object.keys(dateRanges).map(key => ({
    value: key,
    label: dateRanges[key],
}));

const selectableDateRangesWithoutDays = Object.keys(dateRanges)
    .filter(key => !['yesterday', 'today', 'tomorrow'].includes(key))
    .map(key => ({
        value: key,
        label: dateRanges[key],
    }));

const selectableFutureDateRanges = Object.keys(futureDateRanges).map(key => ({
    value: key,
    label: futureDateRanges[key],
}));

const selectablePeriods = periods.map(key => ({
    value: key,
    label: ucFirst(key),
}));

export {
    dateRanges,
    selectableDateRanges,
    selectableDateRangesWithoutDays,
    selectableFutureDateRanges,
    periods,
    selectablePeriods,
};
